'use strict';

/**
 * Provides global access to the application components.
 *
 * @class App
 * @constructor
 * @module Core
 */
export class App {
    location;
    injector;
    compile;
    rootScope;
    models;
    modules;
    parameters;
    debugRenderer;
    provide;
    module;

    constructor() {
        this.models = {};
        this.modules = {};
        this.parameters = {};
    }

    /**
     * Validates and redraws the application with updated data.
     *
     * @method validate
     * @param {Function} [expression] Optional function to execute in angular context
     * @return {App} Self
     */
    validate(expression?) {
        if (this.rootScope.$$phase !== null) {
            if (typeof(expression) === 'function') {
                expression();
            }
        } else {
            this.rootScope.$apply(expression);
        }

        return this;
    }
}

export default new App();



// WEBPACK FOOTER //
// ./src/main/ui/core/application/App.ts